import State from 'store/State';
import { findBar, findTickData } from './marketDataSlice';
import { initialMarketDataState } from 'marketData/store/MarketDataState';
import orderBy from 'lodash/orderBy';

export const selectMarketDataState = (state: State) =>
    state.marketData ?? initialMarketDataState;

export const selectIndigoMarketDataEnabled = (state: State) =>
    selectMarketDataState(state)?.indigoMarketDataEnabled;

export const selectExternalMarketDataSource = (state: State) =>
    selectMarketDataState(state).externalMarketDataSource;

export const selectMarketTickData = (
    state: State,
    bbSymbol: string | undefined
) => findTickData(selectMarketDataState(state).ticks, bbSymbol);

export const selectLatestMarketTickData = (
    state: State,
    bbSymbol: string | undefined
) => {
    const tickData = selectMarketTickData(state, bbSymbol);
    if (!tickData || tickData.ticks.length === 0) {
        return undefined;
    }
    return orderBy(tickData.ticks, ['time'], ['desc'])[0];
};

export const selectMarketBarData = (
    state: State,
    bbSymbol: string,
    binSize: number
) => findBar(selectMarketDataState(state).bars, bbSymbol, binSize);

export const selectMarketBarDataBars = (
    state: State,
    bbSymbol: string,
    binSize: number
) => findBar(selectMarketDataState(state).bars, bbSymbol, binSize)?.bars;

export const selectRefData = (state: State, bbSymbol: string | undefined) =>
    bbSymbol ? selectMarketDataState(state).refData[bbSymbol] : undefined;

export const selectMarketDataMessages = (state: State) =>
    selectMarketDataState(state).messages;

export const selectMarketBarDataMessages = (
    state: State,
    bbSymbol: string,
    binSize: number
) => selectMarketBarData(state, bbSymbol, binSize)?.messages;
